import * as actionTypes from '../actions/actionTypes';

const checkMutations = {
  [actionTypes.CHECK_RECIPIENT_START](state, payload) {
    state.isRecipientsLoading = true;
    state.recipToCreate = payload;
  },
  [actionTypes.CHECK_RECIPIENT_SUCCESS](state, payload) {
    state.isRecipientsLoading = false;
    state.checkStatus = payload;
  },
  [actionTypes.CHECK_RECIPIENT_FAIL](state, payload) {
    state.isRecipientsLoading = false;
    state.recipientError = payload;
    state.recipToCreate = null;
  },
};

const createMutations = {
  [actionTypes.CREATE_RECIPIENT_START](state) {
    state.isRecipientsLoading = true;
  },
  [actionTypes.CREATE_RECIPIENT_SUCCESS](state) {
    state.isRecipientsLoading = false;
    state.recipToCreate = null;
  },
  [actionTypes.CREATE_RECIPIENT_FAIL](state, payload) {
    state.isRecipientsLoading = false;
    state.recipientError = payload;
  },
};

const listMutations = {
  [actionTypes.LIST_RECIPIENTS_START](state) {
    state.isRecipientsLoading = true;
  },
  [actionTypes.LIST_RECIPIENTS_SUCCESS](state, payload) {
    state.isRecipientsLoading = false;
    state.recipients = payload;
  },
  [actionTypes.LIST_RECIPIENTS_FAIL](state, payload) {
    state.isRecipientsLoading = false;
    state.recipientError = payload;
  },
};

const updateMutations = {
  [actionTypes.UPDATE_RECIPIENT_START](state) {
    state.isRecipientsLoading = true;
  },
  [actionTypes.UPDATE_RECIPIENT_SUCCESS](state) {
    state.isRecipientsLoading = false;
  },
  [actionTypes.UPDATE_RECIPIENT_FAIL](state, payload) {
    state.isRecipientsLoading = false;
    state.recipientError = payload;
  },
};

const deleteMutations = {
  [actionTypes.DELETE_RECIPIENT_START](state) {
    state.isRecipientsLoading = true;
  },
  [actionTypes.DELETE_RECIPIENT_SUCCESS](state) {
    state.isRecipientsLoading = false;
  },
  [actionTypes.DELETE_RECIPIENT_FAIL](state, payload) {
    state.isRecipientsLoading = false;
    state.recipientError = payload;
  },
};

const getMutation = {
  [actionTypes.GET_RECIPIENT_START](state) {
    state.isRecipientsLoading = true;
  },
  [actionTypes.GET_RECIPIENT_SUCCESS](state, payload) {
    state.isRecipientsLoading = false;
    state.recipient = payload;
  },
  [actionTypes.GET_RECIPIENT_FAIL](state, payload) {
    state.isRecipientsLoading = false;
    state.recipientError = payload;
  },
};

const getCountMutation = {
  [actionTypes.GET_RECIPIENT_COUNT_START](state) {
    state.isRecipientsLoading = true;
  },
  [actionTypes.GET_RECIPIENT_COUNT_SUCCESS](state, payload) {
    state.isRecipientsLoading = false;
    state.totalRecips = payload;
  },
  [actionTypes.GET_RECIPIENT_COUNT_FAIL](state, payload) {
    state.isRecipientsLoading = false;
    state.recipientError = payload;
  },
};

const setRecipToDeleteMutation = {
  [actionTypes.SET_RECIP_TO_DELETE](state, payload) {
    state.recipToDelete = payload;
  },
};

const clearRecipUpdateMutation = {
  [actionTypes.CLEAR_RECIP_UPDATE_STATE](state) {
    state.recipToCreate = null;
    state.recipToDelete = null;
    state.recipientError = null;
  }
};

const mutations = {
  ...checkMutations,
  ...createMutations,
  ...listMutations,
  ...updateMutations,
  ...deleteMutations,
  ...getMutation,
  ...getCountMutation,
  ...setRecipToDeleteMutation,
  ...clearRecipUpdateMutation,
};

export default mutations;
